import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card, Table, Empty, Divider, Select } from 'antd';

import { Action, updateInArray } from 'fennec-ui'
import Filtered from '../Filtered'
import { DropdownAction } from 'fennec-ui'
import { GET, POST, queryFilterByItem, errorCatch } from 'fennec-ui'
import "./index.css"

import NovayaKomissiiPartneram from '../../forms/NovayaKomissiiPartneram'
import IzmenitKomissiiPartneram from '../../forms/IzmenitKomissiiPartneram';

const { Option } = Select;


function Btn(props) {
    const dispatch = useDispatch();
    const { object, sourceKey, auth, queryFilterContext, setData, soruceID } = props;
    return (
        <>
            <DropdownAction items={[
                {
                    ...props,
                    title: "Изменить",
                    auth: auth,
                    modal: {
                        width: "40%",
                        minWidth: "400px",
                        title: "Изменить комиссию",
                    },
                    object: object,
                    mode: "MenuItem",
                    action: (values, unlock, close) => {
                        POST(auth, '/api/komissiipartneram/update', { ...values, ID: (object) ? object.ID : undefined },
                            ({ data }) => {
                                setData(o => updateInArray(o, data))
                                // dispatch(REDUX_KomissiiPartneram.actions.updateArrayByKey(sourceKey, [data]));
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                    // context: context,
                    sourceKey: sourceKey,
                    soruceID: object?.meropriyatieID,
                    form: IzmenitKomissiiPartneram,
                    queryFilterContext: queryFilterContext
                }
            ]} />
        </>
    )
};

export default function ComissionBlock(props) {
    const dispatch = useDispatch();
    const { auth, source, create, ctx, sourceKey, title, size, event } = props;
    const [loading, setLoading] = useState(false);

    const [data, setData] = useState([]);
    // const data = useSelector(REDUX_KomissiiPartneram.selector.arrayByKey(sourceKey));

    const concatSybmol = (source) => {
        return (source.indexOf("?") >= 0) ? "&" : "?";
    };
    useEffect(() => {
        let src = "";
        if (ctx) {
            let q = queryFilterByItem(ctx);
            if (ctx || q) {
                src = source + ((ctx || q) ? concatSybmol(source) + q : "");
            }
        } else {
            src = source
        }
        if (src) {
            setLoading(true);
            GET(auth, src,
                ({ data }) => {
                    setData(data)
                    // dispatch(REDUX_KomissiiPartneram.actions.setArrayByKey(sourceKey, data));
                    setLoading(false);
                },
                (err) => errorCatch(err, setLoading(false))
            );
        }
    }, [ctx]);

    const filters = [
        {
            name: "Аккаунт",
            value: item => (item.akkaunt) ? item.akkaunt.nomerAkkaunta : "",
            field: "nomerAkkaunta",
            type: "string",
            sort: true,
            filter: true
        },
        {
            name: "Промокод",
            value: item => (item.promokod) ? item.promokod.promokod : "",
            field: "promokod",
            type: "string",
            sort: true,
            filter: true
        },
        {
            name: 'Активная',
            value: item => !item.notActive, //(item.notActive) ? "Да" : "Нет",
            field: "active",
            type: "bool",
            filter: true
        },
        {
            name: 'Неактивная',
            value: item => item.notActive, //(item.notActive) ? "Да" : "Нет",
            field: "notActive",
            type: "bool",
            filter: true
        },
        {
            name: 'Как вычислить счет',
            value: item => (item.kakVichislitAkkaunt) ? item.kakVichislitAkkaunt.nazvanie : "", //(item.notActive) ? "Да" : "Нет",
            field: "kakVichislitAkkaunt",
            type: "string",
            filter: true
        }
    ];
    const columns = () => {
        var c = [];
        c.push({
            title: 'Суть комиссии',
            render: (text, record) => {
                return (record.sutKomissii);
            }
        });
        c.push({
            title: 'Промокод',
            render: (text, record) => {
                return ((record.promokod) ? record.promokod.promokod : "");
            }
        });
        c.push({
            title: 'Процент',
            render: (text, record) => {
                return (record.protsentKomissii);
            }
        });
        c.push({
            title: 'Сумма',
            render: (text, record) => {
                return (record.summaKomissiii);
            }
        });
        c.push({
            title: 'Как вычислить счет',
            render: (text, record) => {
                return ((record.kakVichislitAkkaunt) ? record.kakVichislitAkkaunt.nazvanie : "");
            }
        });

        let organizatorKey = {}
        if (event?.organizatorFederatsiyaID) {
            organizatorKey = { organizatorFederatsiyaID: event?.organizatorFederatsiyaID }
        } else if (event?.organizatorRegionalnoeOtdelenieID) {
            organizatorKey = { organizatorRegionalnoeOtdelenieID: event?.organizatorRegionalnoeOtdelenieID }
        } else if (event?.organizatorShkolaID) {
            organizatorKey = { organizatorShkolaID: event?.organizatorShkolaID }
        } else if (event?.organizatorMeropriyatiyaID) {
            organizatorKey = { organizatorMeropriyatiyaID: event?.organizatorMeropriyatiyaID }
        }

        c.push({
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => (<Btn auth={auth} soruceID={event?.ID} index={index + 1} object={record} create={create} sourceKey={sourceKey} setData={setData} queryFilterContext={(ctx) ? ctx : organizatorKey} />),
        });
        return c;
    };
    const createAction = (values, unlock, close) => {
        POST(auth, "/api/komissiipartneram/new", {
            ...values,
            akkauntID: values?.akkaunt?.ID,
            ...((ctx) ? ctx : {}),
            // ...((context && context.object) ? context.object(ctx) : {}),
            ...((event?.ID) ? { meropriyatieID: event.ID } : {})
        }, //values,
            ({ data }) => {
                if (data) {
                    // dispatch(REDUX_KomissiiPartneram.actions.updateArrayByKey(sourceKey, [data]));
                    setData(o => updateInArray(o, data))
                }
                close();
            },
            (err) => errorCatch(err, unlock));
    };

    const NewElement = () => {
        let organizatorKey = {}
        if (event?.organizatorFederatsiyaID) {
            organizatorKey = { organizatorFederatsiyaID: event?.organizatorFederatsiyaID }
        } else if (event?.organizatorRegionalnoeOtdelenieID) {
            organizatorKey = { organizatorRegionalnoeOtdelenieID: event?.organizatorRegionalnoeOtdelenieID }
        } else if (event?.organizatorShkolaID) {
            organizatorKey = { organizatorShkolaID: event?.organizatorShkolaID }
        } else if (event?.organizatorMeropriyatiyaID) {
            organizatorKey = { organizatorMeropriyatiyaID: event?.organizatorMeropriyatiyaID }
        }

        return (
            <Action {...props}
                mode={"button"}
                // disabled={(context && context.collection && !ctx)}
                auth={auth}
                action={createAction}
                form={NovayaKomissiiPartneram}
                triggerOptions={{
                    type: "primary"
                }}
                title={"Новая комиссия"}
                modal={{
                    width: "40%",
                    minWidth: "400px",
                    title: "Новая комиссия",
                }}
                sourceKey={sourceKey}
                soruceID={event?.ID}
                queryFilterContext={(ctx) ? ctx : organizatorKey}
            />
        )
    };
    return (
        <>
            <Filtered filters={filters} data={data}
                addition={(create && size === "small") ?
                    NewElement() : <></>
                }
                content={items => (
                    <div style={{ backgroundColor: "white", borderRadius: "4px" }}>
                        <div style={{ padding: "10px" }}>
                            {title || <Divider type="horizontal" orientation="left">
                                Комиссии партнерам
                            </Divider>}
                            {create && <>
                                {size !== "small" && <div style={{ paddingBottom: "10px", display: "flex", justifyContent: "flex-end" }}>
                                    {NewElement()}
                                </div>}
                            </>}
                            <Table loading={loading} pagination={false} columns={columns()} dataSource={items} locale={{ emptyText: <Empty description={"Нет комиссий"}></Empty> }} size="small" rowKey={(r) => r.ID} />
                        </div>
                    </div>
                )} />
        </>
    );
}
